import React from 'react';
import { WavesIcon } from 'lucide-react';
interface RiverCityBrandProps {
  compact?: boolean;
}
export function RiverCityBrand({
  compact = false
}: RiverCityBrandProps) {
  return <div className="flex items-center gap-2.5 text-left" aria-label="RiverCity Mortgage" data-id="element-110" data-mp="rk7yzqs07mlp">
      <div className="relative flex h-9 w-10 items-end justify-center overflow-hidden" aria-hidden="true" data-id="element-111" data-mp="mlehln9ljbg9">
        <div className="absolute bottom-2 flex items-end gap-0.5 text-slate-400" data-id="element-112" data-mp="3v0y6ka38i7pi">
          <span className="h-3 w-1.5 bg-current" data-id="element-113" data-mp="3v3155iigd95u" />
          <span className="h-5 w-1.5 bg-current" data-id="element-114" data-mp="3q3ev1hxx8919" />
          <span className="h-7 w-2 bg-current" data-id="element-115" data-mp="8tzylgfova97" />
          <span className="h-4 w-1.5 bg-current" data-id="element-116" data-mp="8urkfzjhhtma" />
          <span className="h-6 w-1.5 bg-current" data-id="element-117" data-mp="3uwuby7j982a" />
          <span className="h-3 w-1.5 bg-current" data-id="element-118" data-mp="3u3wxnugruwt" />
        </div>
        <WavesIcon className="absolute -bottom-0.5 h-6 w-11 text-rcm-500" strokeWidth={2.4} data-id="element-119" data-mp="1k8nai3bxfmsa" />
      </div>
      <div className="leading-none" data-id="element-120" data-mp="1falhapkse733">
        <div className="font-serif text-[21px] tracking-[-0.03em] text-slate-600" data-id="element-121" data-mp="1f9k1y8wqmyfk">
          River<span className="font-semibold" data-id="element-122" data-mp="3fphef920zh7z">City</span>
          {!compact && <span className="ml-0.5 font-medium" data-id="element-123" data-mp="3kouamkese0n8">Mortgage</span>}
        </div>
        {!compact && <div className="mt-1 text-[8px] font-bold uppercase tracking-[0.2em] text-rcm-500" data-id="element-124" data-mp="3pnx7vioiz2kn">
            Home Loans
          </div>}
      </div>
    </div>;
}